// src/components/AnimatedText.jsx
import { useEffect, useRef, useState } from "react";

export default function AnimatedText({ children, className = "", delay = 0 }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setVisible(true), delay);
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [delay]);

  return (
    <div
      ref={ref}
      className={`${className} transition-all duration-700 ease-out transform 
                  ${visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-10"}`}
    >
      {children}
    </div>
  );
}
